<div class="p-3">
    <div mat-dialog-title class="d-flex">
      <h1>Review</h1>
    </div>
    
    <div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="saving">
      <div>
        <mat-spinner color="accent"></mat-spinner>
      </div>
    </div>

    <form [formGroup]="reviewForm" (submit)="saveReview()">
        <div mat-dialog-content class="text-center d-flex justify-content-between flex-column align-items-center">
        <label>Rate this business</label>
        <app-star-rating [rating]="rating"  [starCount]="starCount" [color]="starColor" (ratingUpdated)="onRatingChanged($event)"></app-star-rating>
        </div>
        <mat-form-field class="w-100">
            <mat-label for="title">Title</mat-label>
            <input name="title" matInput formControlName="title">
        </mat-form-field>
    <div mat-dialog-content class="text-center d-flex justify-content-between flex-column align-items-center">
      <textarea formControlName="comment" rows="5" class="w-100"></textarea>
    </div>
    <div mat-dialog-actions class="d-flex mt-4">
      <button type="button" mat-button (click)="onNoClick()">Cancel</button>
      <div class="spacer"></div>
      <button
        mat-raised-button
        type="submit"
        [disabled]="!reviewForm.valid || saving"
        color="primary"

      >
        {{saving ? 'Saving' : 'Save'}}
      </button>
      
      <!-- <button
        mat-raised-button
        [disabled]="!webcamImage && !uploadedImage"
        color="secondary"
        (click)="uploadToBucket()"
      >
        Add Recognition
      </button>
      <button
        mat-raised-button
        [disabled]="!webcamImage && !uploadedImage"
        color="secondary"
        (click)="recognise()"
      >
        Authenticate Face
      </button> -->
    </div>
</form>
    </div>